import { Navigate } from 'react-router-dom';
import { getUserRole } from '../utils/auth';

// Wraps a route element so non-admin users (including anyone navigating
// directly to the URL, not just nav-link clicks) are redirected to Options
// instead of ever rendering the page.
export default function AdminRoute({ children }) {
  return getUserRole() === 'admin' ? children : <Navigate to="/options" replace />;
}
